const actions = {
  SET_STATE: 'groups/SET_STATE',
  GET_DATA: 'groups/GET_DATA',
}

export default actions
